import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Select } from 'antd';
import moment from 'moment';
import { getTimeZoneOptions, myTimeZone } from '../../utils/DataFormatterUtils';
import { UTC_TIME_ZONE } from '../../utils/DataConstants';

require('./OWDatePickerWIthTimeZone.less');

const OWDatePickerWithTimeZone: FC<any> = ({
	disabledStart = moment('1/1/1970', 'MM/DD/YYYY'),
	disabledEnd = moment('1/1/2038', 'MM/DD/YYYY'),
	paramName = 'startAndEndDates',
	timeZoneParamName = 'timeZone',
	otherDisabledDates = [],
	initialStartDate,
	initialEndDate,
	initialTimeZone,
	form,
	showTimeZone = false,
	hideTimezonesWithUtcDefault = false,
	timeZones,
	rules,
	...props
}) => {
	// getTimeZoneOptions offers UTC to nobody by default — it is the zone analytics pins to, not one
	// a user picks off a list. The hidden select is the sole exception, so it asks for that option
	// explicitly: it submits UTC and needs the matching option to back that value. The list is
	// unreachable there anyway (opacity 0, pointer-events none, out of the tab order).
	const timeZoneOptions = useMemo(
		() =>
			getTimeZoneOptions(
				hideTimezonesWithUtcDefault ? [...(timeZones || []), UTC_TIME_ZONE] : timeZones
			),
		[timeZones, hideTimezonesWithUtcDefault]
	);
	const timeZone = useMemo(
		() => (hideTimezonesWithUtcDefault ? UTC_TIME_ZONE : initialTimeZone || myTimeZone()),
		[hideTimezonesWithUtcDefault, initialTimeZone]
	);
	const renderTimeZone = showTimeZone || hideTimezonesWithUtcDefault;

	const disabledDate = (current) => {
		// Can not select days greater/less than database can handle
		return (
			current &&
			(current > disabledEnd ||
				current < disabledStart ||
				otherDisabledDates.some((d) => d === current))
		);
	};

	return (
		<span>
			{form.getFieldDecorator(paramName, {
				...(rules ? { rules } : {}),
				initialValue:
					initialStartDate || initialEndDate
						? [
								initialStartDate && moment(initialStartDate),
								initialEndDate && moment(initialEndDate),
						  ]
						: undefined,
			})(
				<DatePicker.RangePicker
					{...props}
					disabledDate={disabledDate}
					style={
						renderTimeZone && !hideTimezonesWithUtcDefault
							? { borderRadius: '2px 0px 0px 2px' }
							: {}
					}
				/>
			)}
			{renderTimeZone
				? form.getFieldDecorator(timeZoneParamName, {
						initialValue: timeZone,
				  })(
						<Select
							className="tz-select"
							style={{
								display: 'inline-flex',
								alignItems: 'center',
								whiteSpace: 'nowrap',
								width: 75,
								marginLeft: -1,
								borderRadius: '0px 2px 2px 0px',
								...(hideTimezonesWithUtcDefault
									? { opacity: 0, pointerEvents: 'none' as const }
									: {}),
							}}
							tabIndex={hideTimezonesWithUtcDefault ? -1 : undefined}
							aria-hidden={hideTimezonesWithUtcDefault || undefined}
						>
							{timeZoneOptions.map((option) => (
								<Select.Option key={option.value} value={option.value} label={option.label}>
									{option.label}
								</Select.Option>
							))}
						</Select>
				  )
				: null}
		</span>
	);
};

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OWDatePickerWithTimeZone);
